import {Component, OnDestroy, OnInit} from '@angular/core';
import {map, takeUntil} from 'rxjs/operators';
import {NbThemeService} from '@nebular/theme';
import {Subject} from 'rxjs';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <div class="footer-left">
      <span class="created-by">
        Всі права захищені &copy; 2025 <a href="https://nodum.com.ua" target="_blank">Nodum</a>
      </span>
    </div>

    <div class="client-portal-link">
      <img src="assets/images/icon.png" alt="Nodum Icon" class="Nodum-icon"/>
      <a href="https://Nodum.com.ua" target="_blank">Nodum Client Portal</a>
    </div>
  `,
})
export class FooterComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();

  currentTheme = 'default';

  themes = [
    {
      value: 'default',
      name: 'Світла тема',
    },
    {
      value: 'cosmic',
      name: 'Космічна тема',
    },
  ];

  constructor(
    private themeService: NbThemeService,
  ) {
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    this.themeService.onThemeChange()
      .pipe(
        map(({name}) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
